import {Image, View} from "react-native"
import {PlanResourcePeriod, PlanResourcePeriodPrice} from "models"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import Button from "components/chalky-layout/button"
import Card from "components/chalky-layout/card"
import Checkbox from "components/chalky-layout/checkbox"
import {FlashNotifications} from "flash-notifications"
import HappyDog from "./happy-dog.png"
import memo from "set-state-compare/build/memo"
import PageContentsPresentation from "components/page-contents/presentation"
import PropTypes from "prop-types"
import React from "react"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"

export default memo(shapeComponent(class ComponentsPlansSignUpModalStepConfirm extends ShapeComponent {
  static propTypes = {
    onBackPress: PropTypes.func.isRequired,
    onConfirmUpgrade: PropTypes.func.isRequired,
    period: PropTypes.instanceOf(PlanResourcePeriod).isRequired,
    price: PropTypes.instanceOf(PlanResourcePeriodPrice).isRequired
  }

  setup() {
    const {t} = useI18n({namespace: "js.components.plans.sign_up_modal.step_confirm"})
    const {period, price} = this.p

    this.pageContentsLiquidVariables = React.useMemo(() => ({period, price}), [period.id(), price.id()])
    this.termsAndConditionsChecked = false

    this.t = t
  }

  render() {
    const {t} = this.tt

    return (
      <>
        <Image
          source={HappyDog}
          style={this.imageStyle ||= {
            position: "absolute",
            right: 169,
            bottom: 0,
            width: 311,
            height: 265
          }}
        />
        <Card
          large
          onClose={this.tt.onCardClose}
          style={this.cardStyle ||= {width: 928}}
          testID="plans/sign-up-modal/step-confirm"
        >
          <View>
            <PageContentsPresentation
              identifier="plans/sign-up-modal/step-confirm/header"
              liquidVariables={this.tt.pageContentsLiquidVariables}
            />
            <Checkbox
              label={t(".i_agree_to_woof_terms")}
              onChangeChecked={this.tt.onTermsAndConditionsChangeChecked}
              style={this.checkboxStyle ||= {marginTop: 24}}
              testID="agree-to-terms-checkbox"
            />
          </View>
          <View style={this.closeButtonStyle ||= {flexDirection: "row", justifyContent: "end", marginTop: 15}}>
            <Button
              icon="chevron-left"
              onPress={this.tt.onBackPress}
              style={this.backButtonStyle ||= {marginRight: 10}}
            />
            <Button
              onPress={this.tt.onConfirmUpgradePressed}
              primary
              testID="confirm-button"
              title={t(".confirm_upgrade")}
            />
          </View>
        </Card>
      </>
    )
  }

  onBackPress = () => this.p.onBackPress()
  onCardClose = () => this.p.onBackPress()

  onTermsAndConditionsChangeChecked = (newChecked) => {
    this.termsAndConditionsChecked = newChecked
  }

  onConfirmUpgradePressed = () => {
    if (!this.tt.termsAndConditionsChecked) {
      FlashNotifications.error(this.t(".you_must_accept_our_terms"))

      return
    }

    this.p.onConfirmUpgrade()
  }
}))
